import { breakpoints } from '@/utils/util-breakpoints';
import { GlobalToken } from 'antd';
import styled from 'styled-components';

export const RoomContainer = styled.div<{ theme: { token: GlobalToken } }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }

  @media (max-width: ${breakpoints.md - 1}px) {
    margin-bottom: 24px;
  }

  .room-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border: 1px solid ${({ theme }) => theme.token.colorBorderSecondary};

    @media (max-width: ${breakpoints.md - 1}px) {
      padding: 16px;
      border-radius: 4px 4px 0 0;
      border: 1px solid ${({ theme }) => theme.token.colorBorderSecondary};
    }
  }

  .room-title {
    color: ${({ theme }) => theme.token.colorTextHeading};
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    @media (max-width: ${breakpoints.md - 1}px) {
      color: ${({ theme }) => theme.token.colorText};
    }
  }

  .room-content {
    padding: 0 ${({ theme }) => theme.token.paddingLG}px ${({ theme }) => theme.token.paddingLG}px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    border: 1px solid ${({ theme }) => theme.token.colorBorderSecondary};
    border-top: none;
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.token.paddingLG}px;

    @media (max-width: ${breakpoints.md - 1}px) {
      padding: ${({ theme }) => theme.token.paddingLG}px;
      border: 1px solid ${({ theme }) => theme.token.colorBorderSecondary};
      border-top: none;
      border-radius: 0 0 4px 4px;
      gap: 24px;
    }
  }

  .compressor-section {
    border-bottom: 1px solid ${({ theme }) => theme.token.colorBorderSecondary};
    padding-bottom: ${({ theme }) => theme.token.paddingLG}px;
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.token.paddingLG}px;

    @media (max-width: ${breakpoints.md - 1}px) {
      padding-bottom: 0;
      border-bottom: none;
      gap: ${({ theme }) => theme.token.paddingLG}px;
    }
  }

  .section-row {
    width: 100%;
    padding-top: ${({ theme }) => theme.token.paddingLG}px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media (max-width: ${breakpoints.lg - 1}px) {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
    }

    @media (max-width: ${breakpoints.md - 1}px) {
      padding: 0;
    }
  }

  .section-label {
    flex: 1;
    color: ${({ theme }) => theme.token.colorTextBase};
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;

    @media (max-width: ${breakpoints.md - 1}px) {
      margin-bottom: 8px;
      font-size: 14px;
      font-weight: 500;
      color: ${({ theme }) => theme.token.colorTextSecondary};
    }
  }

  .compressors-table {
    width: 100%;
    display: flex;
    flex-direction: column;

    .ant-select-selection-item {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .ant-select {
      max-width: 100%;
    }
  }

  .control-group-class {
    width: 440px;
    display: flex;
    align-items: center;

    @media (max-width: ${breakpoints.lg}px) {
      width: 100%;
    }

    @media (max-width: ${breakpoints.md - 1}px) {
      width: 100%;
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
    }

    .compressor-select {
      flex-grow: 1;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;

      @media (max-width: ${breakpoints.lg - 1}px) {
        width: 100%;
        border-radius: 8px;

        &.ant-select-disabled {
          .ant-select-selector {
            background-color: ${({ theme }) => theme.token.colorBgContainer};
            color: ${({ theme }) => theme.token.colorText};
            cursor: pointer;
          }
        }

        .ant-select-selection-item {
          background-color: ${({ theme }) => theme.token.colorFillSecondary};
          color: ${({ theme }) => theme.token.colorText};
          border-radius: 2px;
          padding: 0 4px;
          margin-right: 4px;
          border: none;
          display: flex;
          align-items: center;
          height: 24px;

          .ant-select-selection-item-content {
            margin-right: 6px;
          }

          .ant-select-selection-item-remove {
            color: ${({ theme }) => theme.token.colorTextSecondary};
          }
        }

        .compressor-tag {
          display: inline-flex;
          align-items: center;
          background-color: ${({ theme }) => theme.token.colorFillSecondary};
          color: ${({ theme }) => theme.token.colorText};
          border-radius: 2px;
          padding: 0 4px;
          margin-right: 4px;
          font-size: 14px;
          height: 24px;
        }

        .compressor-tag-close {
          margin-left: 4px;
          font-size: 14px;
          color: ${({ theme }) => theme.token.colorTextSecondary};
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }
      }
    }

    .add-manual-compressor-button {
      width: 40px;
      height: 40px;
      border-radius: 0 8px 8px 0;
      background: ${({ theme }) => theme.token.colorBgContainer};
      padding: 0;
      margin: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      border-right: 1px ${({ theme }) => theme.token.colorBorder} solid;
      border-top: 1px ${({ theme }) => theme.token.colorBorder} solid;
      border-bottom: 1px ${({ theme }) => theme.token.colorBorder} solid;
      box-shadow: none;

      .anticon {
        color: ${({ theme }) => theme.token.colorTextQuaternary};
      }

      @media (max-width: ${breakpoints.md - 1}px) {
        width: auto;
        height: auto;
        background: transparent;
        border-radius: 0;
        outline: none;
        padding: 4px 0;
        color: ${({ theme }) => theme.token.colorPrimary};
        display: inline-flex;
        justify-content: flex-start;
        align-items: center;
        line-height: 22px;
        border: none;

        .anticon {
          color: ${({ theme }) => theme.token.colorPrimary};
          margin-right: 8px;
          display: inline-flex;
          align-items: center;
          vertical-align: middle;
          font-size: 14px;
          position: relative;
          top: -1px;
        }

        .button-text {
          display: inline-block;
          vertical-align: middle;
          line-height: 1;
        }

        &:hover,
        &:focus {
          background: transparent;
        }
      }
    }
  }

  .remove-room-link {
    color: ${({ theme }) => theme.token.colorPrimary};
    font-size: 14px;
    cursor: pointer;
  }
`;
